import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { DatePipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import { Router } from "@angular/router";
import { TIPOS_OPERACAO } from 'src/app/model/operacao-garantida.model';
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { Arquivo, TipoConteudo } from 'src/app/model/arquivo.model';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { IntegracaoService } from '../integracao.service';

export enum TipoIpoc {
  CONVENCIONAL = 1,
  COOPERATIVA = 2,
}

@Component({
  selector: "app-protocolo-cadastro",
  templateUrl: "./ipoc-cadastro.component.html",
  standalone: false
})
export class IpocCadastroComponent implements OnInit {

  public tiposOperacao = TIPOS_OPERACAO;
  public cadastroForm: UntypedFormGroup;
  public tipoDaOperacao: string;
  public desabilitaTrocaIdOperacaoAgente: boolean = false;
  public operacaoCreditoLivre: string;
  public arquivo: Arquivo;
  public conteudoArquivo: string;
  public tipoConteudo: TipoConteudo;
  private ocorrencias: OcorrenciaValidacaoVO[] = [];
  private modalidadeGarantia: string;
  private nomeModalidade: string;
  private usuarioLogado: Usuario;
  public agenteFinanceiroEhAssociado: boolean;
  private agentesFinanceirosAssociados: string[] = [];

  listaTipoIpoc = [
    { label: 'Convencional', value: TipoIpoc.CONVENCIONAL },
    { label: 'Cooperativa', value: TipoIpoc.COOPERATIVA }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private modalService: BnModalMessageService,
    private protocoloArquivoService: ProtocoloArquivoService,
    private messageService: MessageChannelService,
    private datePipe: DatePipe,
    private modalidadeService: ModalidadeService,
    private integracaoService: IntegracaoService,
    private usuarioService: BnUsuarioService,
  ) { }

  ngOnInit(): void {
    this.createReactiveForm();
    this.preencheForm();

    this.cadastroForm.get('tipoIpoc')?.valueChanges.subscribe(() => {
      this.cadastroForm.get('ipoc')?.updateValueAndValidity();
    });

    this.operacaoCreditoLivre = this.tiposOperacao[0].codigo;

    this.modalidadeService.modalidade$.subscribe((mod) => {
      this.modalidadeGarantia = mod;
      for (let modalidade of this.modalidadeService.getModalidades()) {
        if (modalidade.sigla == mod) {
          this.nomeModalidade = modalidade.nome;
        }
      }
    });

    this.usuarioService.usuario$.subscribe(usuario => {
      this.usuarioLogado = usuario;
      this.verificarAgenteFinanceiroPossuiAssociados();
      this.cadastroForm.get('ipoc')?.updateValueAndValidity();
    });
  }

  public createReactiveForm(): UntypedFormGroup {
    this.cadastroForm = this.formBuilder.group({
      tipoTransacao: new UntypedFormControl({ value: null, disabled: false }, Validators.required),
      tipoOperacao: new UntypedFormControl({ value: null, disabled: false }, Validators.required),
      idOperacaoCreditoLivre: new UntypedFormControl({ value: null, disabled: false }, [Validators.required, Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]),
      sistemaRepasse: new UntypedFormControl({ value: null, disabled: true }, Validators.required),
      contratoRepasse: new UntypedFormControl({ value: null, disabled: true }, Validators.required),
      mesReferencia: new UntypedFormControl({ value: null, disabled: false }, Validators.required),
      ipoc: new UntypedFormControl({ value: null, disabled: false }, [Validators.required, Validators.minLength(21), Validators.maxLength(67), this.validarRaizIpoc()]),
      dataEnvio: new UntypedFormControl({ value: null, disabled: false }, Validators.required),
      novoIdOperacaoAgenteCreditoLivre: new UntypedFormControl({ value: null, disabled: true }, [Validators.required, Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]),
      tipoIpoc: new UntypedFormControl({ value: TipoIpoc.CONVENCIONAL, disabled: true }),
    });

    return this.cadastroForm;
  }

  public preencheForm() {
    this.tipoDaOperacao = this.tiposOperacao[0].codigo;
    this.cadastroForm.patchValue({
      tipoOperacao: this.tipoDaOperacao
    });
  }

  public exibirMensagemSucesso = (res) => {
    const msgRetorno: MensagemRetornoAssincrono = res;
    const mensagemSucesso = `${msgRetorno.mensagem} Id de protocolo: ${msgRetorno.idProtocolo}`;

    this.messageService.addMessage({
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: mensagemSucesso
    });
    this.cadastroForm.reset();
    this.voltarParaPesquisa();
    // this.router.navigate(['/integracao/scr/ipoc']);
  };

  public exibirMensagemErro = (err) => {
    this.ocorrencias = this.protocoloArquivoService.ocorrencias;
    this.limpar();
  };

  public enviar() {
    let tipoTransacao = this.cadastroForm.get('tipoTransacao').value;

    let sistemaRepasse = this.cadastroForm.get('sistemaRepasse').value;
    if (sistemaRepasse == null) sistemaRepasse = '';

    let contratoRepasse = this.cadastroForm.get('contratoRepasse').value;
    if (contratoRepasse == null) contratoRepasse = '';

    let idOperacaoCreditoLivre = this.cadastroForm.get('idOperacaoCreditoLivre').value;
    if (idOperacaoCreditoLivre == null) idOperacaoCreditoLivre = '';

    let mesReferencia = this.cadastroForm.get('mesReferencia').value;
    mesReferencia = this.datePipe.transform(mesReferencia, 'yyyyMM');
    if (mesReferencia == null) mesReferencia = '';

    let ipoc = this.cadastroForm.get('ipoc').value;
    if (ipoc == null) ipoc = '';

    let dataEnvio = this.cadastroForm.get('dataEnvio').value;
    dataEnvio = this.datePipe.transform(dataEnvio, 'yyyy-MM-dd');
    if (dataEnvio == null) dataEnvio = '';

    let novoIdOperacaoAgenteCreditoLivre = this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').value;
    if (novoIdOperacaoAgenteCreditoLivre == null) novoIdOperacaoAgenteCreditoLivre = '';

    let tipoIpoc = this.cadastroForm.get('tipoIpoc').value;
    if (tipoIpoc == null) tipoIpoc = '';

    this.conteudoArquivo =
      tipoTransacao + ";" +
      this.modalidadeGarantia + ';' +
      idOperacaoCreditoLivre + ";" +
      sistemaRepasse + ";" +
      contratoRepasse + ";" +
      mesReferencia + ";" +
      ipoc + ";" +
      dataEnvio + ";" +
      novoIdOperacaoAgenteCreditoLivre + ";" +
      tipoIpoc;

    this.arquivo = new Arquivo();
    this.arquivo.filename = '';
    this.arquivo.filetype = 'csv';
    this.arquivo.value = this.conteudoArquivo;
    this.arquivo.tipoConteudo = TipoConteudo.ATUALIZACAO_SCR;

    console.log(this.conteudoArquivo);

    this.protocoloArquivoService.enviarArquivo(this.arquivo, this.arquivo.tipoConteudo, false, true)
      .subscribe(this.exibirMensagemSucesso, this.exibirMensagemErro);

    this.cadastroForm.reset();
    this.cadastroForm.patchValue({ tipoIpoc: TipoIpoc.CONVENCIONAL });
    this.cadastroForm.get('tipoIpoc')?.disable();
  }

  public liberaOperacaoRepasse() {
    if (this.cadastroForm.get('tipoOperacao').value == this.tiposOperacao[1].codigo) {
      this.cadastroForm.get('sistemaRepasse').enable();
      this.cadastroForm.get('contratoRepasse').enable();
      this.cadastroForm.get('mesReferencia').enable();
      this.cadastroForm.get('ipoc').enable();
      this.cadastroForm.get('dataEnvio').enable();
      this.cadastroForm.get('idOperacaoCreditoLivre').disable();
      this.cadastroForm.get('idOperacaoCreditoLivre').setValue("");
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').disable();
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').setValue("");
      this.cadastroForm.get('tipoTransacao').reset();

      if (this.agenteFinanceiroEhAssociado) {
        this.cadastroForm.get('tipoIpoc')?.enable();
        if (!this.cadastroForm.get('tipoIpoc')?.value) {
          this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
        }
      } else {
        this.cadastroForm.get('tipoIpoc')?.disable();
        this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
      }

      this.desabilitaTrocaIdOperacaoAgente = true;
    } else {
      this.cadastroForm.get('sistemaRepasse').disable();
      this.cadastroForm.get('sistemaRepasse').setValue("");
      this.cadastroForm.get('contratoRepasse').disable();
      this.cadastroForm.get('contratoRepasse').setValue("");
      this.cadastroForm.get('idOperacaoCreditoLivre').enable();
      this.cadastroForm.get('tipoIpoc')?.disable();
      this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
      this.desabilitaTrocaIdOperacaoAgente = false;
    }
    this.cadastroForm.get('ipoc')?.updateValueAndValidity();
  }

  public trocaIdOperacaoAgente() {
    if (this.cadastroForm.get('tipoTransacao').value == 'O' && this.operacaoCreditoLivre) {
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').enable();
      this.cadastroForm.get('sistemaRepasse').disable();
      this.cadastroForm.get('sistemaRepasse').setValue("");
      this.cadastroForm.get('contratoRepasse').disable();
      this.cadastroForm.get('contratoRepasse').setValue("");
      this.cadastroForm.get('mesReferencia').disable();
      this.cadastroForm.get('mesReferencia').setValue("");
      this.cadastroForm.get('ipoc').disable();
      this.cadastroForm.get('ipoc').setValue("");
      this.cadastroForm.get('dataEnvio').disable();
      this.cadastroForm.get('dataEnvio').setValue("");
    } else if (this.cadastroForm.get('tipoTransacao').value == 'A') {
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').disable();
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').setValue("");
      this.cadastroForm.get('ipoc').enable();
      this.cadastroForm.get('dataEnvio').enable();
      this.cadastroForm.get('mesReferencia').enable();
      this.cadastroForm.get('tipoIpoc')?.disable();
      this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
    } else if (this.cadastroForm.get('tipoOperacao').value == this.tiposOperacao[1].codigo) {
      if (this.agenteFinanceiroEhAssociado) {
        this.cadastroForm.get('tipoIpoc')?.enable();
        if (!this.cadastroForm.get('tipoIpoc')?.value) {
          this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
        }
      } else {
        this.cadastroForm.get('tipoIpoc')?.disable();
        this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
      }
    } else {
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').disable();
      this.cadastroForm.get('novoIdOperacaoAgenteCreditoLivre').setValue("");
      this.cadastroForm.get('ipoc').enable();
      this.cadastroForm.get('dataEnvio').enable();
      this.cadastroForm.get('mesReferencia').enable();
    }
    this.cadastroForm.get('ipoc')?.updateValueAndValidity();
  }

  public voltarParaPesquisa() {
    if (this.cadastroForm.pristine) {
      this.router.navigate(['/integracao/scr/ipoc']);
    } else {
      this.abreModalConfirmacao("Descartar nova ocorrência?").then(
        (resp) => {
          if (resp === true) {
            this.router.navigate(['/integracao/scr/ipoc']);
          }
        }
      );
    }
  }

  public async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';
    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  public limpar() {
    this.cadastroForm.reset();
    this.cadastroForm.patchValue({ tipoIpoc: TipoIpoc.CONVENCIONAL });
    this.cadastroForm.get('tipoIpoc')?.disable();
    this.preencheForm();
    this.liberaOperacaoRepasse();
  }

  public verificarAgenteFinanceiroPossuiAssociados() {
    const cnpj = this.usuarioLogado.cnpj;
    this.integracaoService.getAgenteFinanceiroPossuiAssociados(cnpj).subscribe(
      (response: boolean) => {
        if (response === true) {
          this.agenteFinanceiroEhAssociado = true;
          this.setTipoIpocObrigatorio();
          this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);

          if (this.cadastroForm.get('tipoOperacao')?.value == this.tiposOperacao[1].codigo) {
            this.cadastroForm.get('tipoIpoc')?.enable();
          } else {
            this.cadastroForm.get('tipoIpoc')?.disable();
          }

          this.buscarAgentesAssociados();
        } else {
          this.agenteFinanceiroEhAssociado = false;
          this.cadastroForm.get('tipoIpoc')?.disable();
          this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
          this.agentesFinanceirosAssociados = [];
          this.cadastroForm.get('ipoc')?.updateValueAndValidity();
        }
      }, () => {
        this.agenteFinanceiroEhAssociado = false;
        this.cadastroForm.get('tipoIpoc')?.disable();
        this.cadastroForm.get('tipoIpoc')?.setValue(TipoIpoc.CONVENCIONAL);
        this.agentesFinanceirosAssociados = [];
        this.cadastroForm.get('ipoc')?.updateValueAndValidity();
      });
  }

  private buscarAgentesAssociados() {
    const cnpj = this.usuarioLogado.cnpj;
    this.integracaoService.getAgenteFinanceiroAssociados(cnpj).subscribe(
      (response: string[]) => {
        this.agentesFinanceirosAssociados = response ?? [];
        this.cadastroForm.get('ipoc')?.updateValueAndValidity();
      },
      () => {
        this.agentesFinanceirosAssociados = [];
        this.cadastroForm.get('ipoc')?.updateValueAndValidity();
      }
    );
  }

  setTipoIpocObrigatorio() {
    const tipoIpoc = this.cadastroForm.get('tipoIpoc');
    if (!tipoIpoc?.hasValidator(Validators.required)) {
      tipoIpoc?.setValidators([Validators.required]);
      tipoIpoc?.updateValueAndValidity();
    }
  }

  private somenteAlfaNum(v: any): string {
    return (v ?? '').toString().toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  private raiz8AlfaNum(v: any): string {
    const norm = this.somenteAlfaNum(v);
    return norm.length >= 8 ? norm.substring(0, 8) : '';
  }

  private validarRaizIpoc(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const raizIpoc = this.raiz8AlfaNum(control.value);
      if (!raizIpoc) return null;
        const raizAgente = this.raiz8AlfaNum(this.usuarioLogado?.cnpj);

        const raizesAssociadas = new Set(
          (this.agentesFinanceirosAssociados ?? [])
            .map(cnpj => this.raiz8AlfaNum(cnpj))
            .filter(r => r.length === 8)
        );

        const pertenceAoAssociado = raizesAssociadas.has(raizIpoc);
        const pertenceAoProprioAgente = raizIpoc === raizAgente;

        if (pertenceAoAssociado || pertenceAoProprioAgente) return null;

        return { raizIpocNaoAssociada: { raizIpoc } };
    };
  }
}